exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agencySearchForm__form___g5aDg {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px; }\n  .agencySearchForm__form___g5aDg .ant-form-item {\n    display: flex;\n    align-items: center;\n    margin: 0; }\n  .agencySearchForm__form___g5aDg .ant-form-item-control {\n    line-height: normal; }\n\n.agencySearchForm__email___3kqVC {\n  width: 180px; }\n\n.agencySearchForm__button___37RZH {\n  height: 54px;\n  padding: 0 22px;\n  font-weight: 600; }\n", ""]);

// exports
exports.locals = {
	"form": "agencySearchForm__form___g5aDg",
	"email": "agencySearchForm__email___3kqVC",
	"button": "agencySearchForm__button___37RZH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageAgencyPage/styles/agencySearchForm.scss
// module id = 4055
// module chunks = 6